import { Phone } from "lucide-react";
import { WaIcon } from "./icons";
import { PHONE_TEL, WHATSAPP_URL } from "@/lib/constants";

export default function StickyCta() {
  return (
    <>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="hidropro-desktop-floating-whatsapp-button"
        aria-label="Solicitar atendimento pelo WhatsApp"
        className="fixed bottom-6 right-6 z-50 hidden h-14 w-14 items-center justify-center rounded-full bg-wa text-white shadow-[0_12px_30px_rgba(37,211,102,0.4)] transition-all duration-300 hover:scale-105 hover:bg-wa-hover active:scale-95 lg:flex"
      >
        <WaIcon className="h-7 w-7" />
      </a>

      <div className="fixed inset-x-0 bottom-0 z-50 border-t border-[rgba(10,92,140,0.2)] bg-white/92 p-3 backdrop-blur lg:hidden" style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }} data-testid="hidropro-mobile-sticky-cta">
      <div className="flex items-center gap-2.5">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="hidropro-mobile-sticky-whatsapp-button"
          className="flex h-12 flex-1 items-center justify-center gap-2.5 rounded-full bg-wa font-semibold text-white shadow-[0_8px_24px_rgba(37,211,102,0.35)] active:scale-[0.98]"
        >
          <WaIcon className="h-5 w-5" />
          Solicitar atendimento pelo WhatsApp
        </a>
        <a
          href={PHONE_TEL}
          data-testid="hidropro-mobile-sticky-phone-button"
          aria-label="Ligar para HidroPro"
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-2 border-[#0A5C8C] text-[#0A5C8C] active:scale-[0.98]"
        >
          <Phone className="h-5 w-5" />
        </a>
      </div>
      </div>
    </>
  );
}
